import { render, staticRenderFns } from "./roster.vue?vue&type=template&id=018570ed&scoped=true&"
import script from "./roster.vue?vue&type=script&lang=js&"
export * from "./roster.vue?vue&type=script&lang=js&"
import style0 from "./roster.vue?vue&type=style&index=0&id=018570ed&scoped=true&lang=css&"
import style1 from "./roster.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018570ed",
  null
  
)

export default component.exports